module.exports = __webpack_public_path__ + "img/tutorial_exams_01.9ff251ec.gif";